// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__4Y7cq","succesfulMessageTitle":"ForgotPassword_succesfulMessageTitle__Ol0Lo","succesfulBack":"ForgotPassword_succesfulBack__cXeKc"};